module.exports = __webpack_public_path__ + "img/f63b8ce.jpg";